export class UserAuswahlGebaeude {
    idGebaeudeList: number[] = []; 
    idKgeList: number[] = []; 

    preisstand!: number;
    preisfaktor!: number;
 

  }
  